
import Vue from 'vue'
import debounce from 'debounce'

const SearchInput = Vue.extend({
  computed: {
    search_query: function() {
      return this.$store.state.search_query || ''
    },
  },
  methods: {
    onInput: debounce(function(this: typeof SearchInput, { target }) {
      this.$store.dispatch('enter_search', target.value.trim())
    }, 300),
    clearSearch() {
      this.$store.dispatch('reset_search')
    },
  },
})

export default SearchInput
